    /**
     * Initialize smooth scroll for in-page anchor links on buttons
     */
    function initAnchorSmoothScroll() {
        const anchorButtons = document.querySelectorAll('a.button[href^="#"]');

        if (!anchorButtons.length) return;

        anchorButtons.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                const href = btn.getAttribute('href');
                if (!href || href === '#') return;

                const target = document.querySelector(href);
                if (!target) return;

                e.preventDefault();

                // Use Lenis if available for consistent, slightly slower smooth scrolling
                if (window.lenis && typeof window.lenis.scrollTo === 'function') {
                    window.lenis.scrollTo(target, {
                        duration: 2 // seconds, slightly slower than default
                    });
                } else {
                    target.scrollIntoView({
                        behavior: 'smooth',
                        block: 'bottom'
                    });
                }
            });
        });
    }

    /**
     * Initialize masthead scroll active state
     * Adds .scroll-active class when scrolled past threshold (default 200px)
     */
    function initMastheadScrollActive(threshold = 200) {
        const masthead = document.querySelector('#masthead');
        if (!masthead) return;

        function updateScrollState() {
            const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

            if (scrollY > threshold) {
                masthead.classList.add('scroll-active');
            } else {
                masthead.classList.remove('scroll-active');
            }
        }

        // Use Lenis scroll event if available, otherwise use regular scroll
        if (window.lenis && typeof window.lenis.on === 'function') {
            window.lenis.on('scroll', updateScrollState);
        } else {
            window.addEventListener('scroll', updateScrollState, { passive: true });
        }

        // Check initial state
        updateScrollState();
    }

    /**
     * Initialize masthead scroll direction detection
     * Adds .scrolled class when scrolling down past threshold, removes it when scrolling up
     */
    function initMastheadScrollDirection(threshold = 100) {
        const masthead = document.querySelector('#masthead');
        if (!masthead) return;

        let lastScrollY = window.scrollY;
        let scrollStartY = window.scrollY;
        let lastDirection = null;

        function updateScrollDirection() {
            const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

            const direction = scrollY > lastScrollY ? 'down' : scrollY < lastScrollY ? 'up' : null;

            // Reset the start point whenever direction changes
            if (direction && direction !== lastDirection) {
                scrollStartY = scrollY;
                lastDirection = direction;
            }

            const delta = Math.abs(scrollY - scrollStartY);

            if (direction === 'down' && delta >= threshold) {
                masthead.classList.add('scrolled');
            } else if (direction === 'up' && delta >= threshold) {
                masthead.classList.remove('scrolled');
            }

            lastScrollY = scrollY;
        }

        if (window.lenis && typeof window.lenis.on === 'function') {
            window.lenis.on('scroll', updateScrollDirection);
        } else {
            window.addEventListener('scroll', updateScrollDirection, { passive: true });
        }
    }

    /**
     * Initialize mobile navigation
     */
    function initMobileNavigation() {
        const mobnavToggle = document.querySelector('#masthead .mobnav-toggle');
        const mobnavMenu = document.querySelector('#masthead #site-navigation .nav-menu');

        if (mobnavToggle && mobnavMenu) {
            mobnavToggle.addEventListener('click', () => {
                mobnavToggle.classList.toggle('toggled');
                mobnavMenu.classList.toggle('toggled');
            });
        }
    }
